import it from './locale/it';

export const DEFAULT_LOCALE = 'it';

// vue-i18n 9 treats `@` as the linked-message operator (`@:key`) and its
// JIT message compiler throws "Invalid linked format" on legacy strings
// that contain a literal `@` (e.g. "@ to reference", "name@example.com").
// This codebase uses ZERO intentional `@:` linked messages, so escaping
// every literal `@` to vue-i18n's literal slot `{'@'}` is safe and renders
// an actual `@`. Applied to all loaded locale messages.
const escapeAtInMessages = (value) => {
  if (typeof value === 'string') {
    return value.includes('@') ? value.replace(/@/g, "{'@'}") : value;
  }
  if (Array.isArray(value)) {
    return value.map(escapeAtInMessages);
  }
  if (value && typeof value === 'object') {
    return Object.keys(value).reduce((acc, key) => {
      acc[key] = escapeAtInMessages(value[key]);
      return acc;
    }, {});
  }
  return value;
};

const localeLoaders = {
  de: () => import(/* webpackChunkName: "dashboard-locale-de" */ './locale/de'),
  en: () => import(/* webpackChunkName: "dashboard-locale-en" */ './locale/en'),
  es: () => import(/* webpackChunkName: "dashboard-locale-es" */ './locale/es'),
  fr: () => import(/* webpackChunkName: "dashboard-locale-fr" */ './locale/fr'),
  it: () => Promise.resolve({ default: it }),
  pt: () => import(/* webpackChunkName: "dashboard-locale-pt" */ './locale/pt'),
};

const loadedLocales = new Set([DEFAULT_LOCALE]);

export const normalizeLocale = (locale = DEFAULT_LOCALE) => {
  const language = String(locale || DEFAULT_LOCALE).split(/[-_]/)[0];
  return localeLoaders[language] ? language : DEFAULT_LOCALE;
};

export const loadLocaleMessages = async (i18n, locale = DEFAULT_LOCALE) => {
  const normalizedLocale = normalizeLocale(locale);

  // vue-i18n 9 legacy mode: the instance API lives under `.global`.
  const i18nGlobal = i18n.global || i18n;

  if (!loadedLocales.has(normalizedLocale)) {
    try {
      const localeModule = await localeLoaders[normalizedLocale]();
      i18nGlobal.setLocaleMessage(
        normalizedLocale,
        escapeAtInMessages(localeModule.default || localeModule)
      );
      loadedLocales.add(normalizedLocale);
    } catch (error) {
      i18nGlobal.locale = DEFAULT_LOCALE;
      return DEFAULT_LOCALE;
    }
  }

  i18nGlobal.locale = normalizedLocale;
  return normalizedLocale;
};

export default { [DEFAULT_LOCALE]: escapeAtInMessages(it) };
